import { MessageCircle } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";

export default function WhatsAppFloat() {
    const { settings } = useSettings();
    const number = settings?.whatsapp || "919876543210";
    const href = `https://wa.me/${number}?text=${encodeURIComponent(
        `Hi ${settings?.business_name || "Jassi Wood Works"}, I'd like to discuss a custom woodworking project.`
    )}`;
    return (
        <a
            data-testid="whatsapp-float"
            href={href}
            target="_blank"
            rel="noreferrer"
            aria-label="Chat on WhatsApp"
            className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white w-14 h-14 rounded-full shadow-xl flex items-center justify-center hover:scale-110 transition-transform"
        >
            <MessageCircle size={24} />
        </a>
    );
}
